/**
 * The z-index of Popup components.
 */
let globalZIndex = 1200

/** the global z-index is automatically incremented after reading */
export const useGlobalZIndex = () => ++globalZIndex

/** reset the global z-index */
export const setGlobalZIndex = (val) => {
  globalZIndex = val
}
